import React from "react";
import ChipEditor from "./ChipEditor";
import PhotoUploader from "./PhotoUploader";
import { DiagramButton } from "./Diagram";
import { LibIcon, Tag, Label } from "./ui";
import { FF, T } from "../lib/constants";

// Eén oefening als kaart (build 2.5), gebruikt voor de Training Deck én voor eigen en
// gedeelde oefeningen in de bibliotheek. `extra` komt onder de titel (auteur, delen).
export default function DrillCard({ mob, item, lv, sectionLabel, canEdit, onField, clubId, extra }) {
  var ink = lv.ink || lv.color;
  var pad = mob ? "14px 16px" : "16px 22px";
  var h2 = { margin: "0 0 6px", fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: T.muted };
  var area = { width: "100%", boxSizing: "border-box", border: "1px solid " + T.line, borderRadius: 8, padding: 10, fontSize: 14, lineHeight: 1.6, resize: "vertical", outline: "none", color: "#4A4740", fontFamily: FF, background: "#fff" };
  var text = { margin: 0, fontSize: 14, lineHeight: 1.65, color: "#4A4740", whiteSpace: "pre-wrap" };

  return (
    <article style={{ background: T.card, borderRadius: 18, border: "1px solid " + T.line2, overflow: "hidden", fontFamily: FF }}>
      <div style={{ background: T.soft, borderBottom: "1px solid " + T.line }}>
        {item.photo
          ? <img src={item.photo} alt="" decoding="async" style={{ width: "100%", maxHeight: 460, objectFit: "contain", display: "block", background: "#F0EDE6" }} />
          : (!canEdit && <div style={{ height: mob ? 72 : 96, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, color: "#8A857B", fontSize: 13, fontWeight: 600 }}><LibIcon name="image" size={20} />Geen foto</div>)}
        {canEdit && <PhotoUploader clubId={clubId} photo={item.photo} onChange={function (v) { onField("photo", v); }} />}
      </div>

      <div style={{ padding: pad, borderBottom: "1px solid " + T.line, display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8, fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: ink }}>
            <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: 3, background: lv.color }} />{sectionLabel}
          </span>
          <DiagramButton diagram={item.diagram} canEdit={canEdit} title={item.name} onSave={function (v) { onField("diagram", v); }} />
        </div>
        {canEdit
          ? <input value={item.name || ""} aria-label="Naam van de oefening" onChange={function (e) { onField("name", e.target.value); }} placeholder="Naam van de oefening"
              style={{ width: "100%", boxSizing: "border-box", fontFamily: FF, fontSize: mob ? 20 : 24, border: "1px solid " + T.line, borderRadius: 10, padding: "8px 12px", outline: "none", color: T.ink, fontWeight: 800 }} />
          : <h1 style={{ margin: 0, fontSize: mob ? 22 : 26, color: T.ink, fontWeight: 800, lineHeight: 1.2 }}>{item.name || "Naamloze oefening"}</h1>}
        {extra}
        {canEdit
          ? <div><Label>Tags</Label><ChipEditor items={item.tags || []} onChange={function (v) { onField("tags", v); }} placeholder="Tag toevoegen..." color={ink} /></div>
          : ((item.tags || []).length > 0 && <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{item.tags.map(function (t, i) { return <Tag key={i} text={t} lv={lv} />; })}</div>)}
      </div>

      <div style={{ padding: pad, borderBottom: "1px solid " + T.line }}>
        <h2 style={h2}>Beschrijving</h2>
        {canEdit
          ? <textarea value={item.description || ""} aria-label="Beschrijving" onChange={function (e) { onField("description", e.target.value); }} placeholder="Uitleg..." rows={5} style={area} />
          : <p style={text}>{item.description || "—"}</p>}
      </div>
      <div style={{ padding: pad, background: T.soft }}>
        <h2 style={h2}>Overige informatie</h2>
        {canEdit
          ? <textarea value={item.extraInfo || ""} aria-label="Overige informatie" onChange={function (e) { onField("extraInfo", e.target.value); }} placeholder="Tips, variaties..." rows={4} style={area} />
          : <p style={text}>{item.extraInfo || "—"}</p>}
      </div>
    </article>
  );
}
